import axios from '../utils/axios';

export default function bulkAssignNTCPremiumJobs(adminId, data) {
    return axios.post(`/admin/${adminId}/ntc-premium-jobs/bulk-assign`, data)
        .then(res => res.data)
        .catch(err => err);
}
